
import React, { Children, useEffect, useRef, useState } from 'react';
import { Box, Container, FormControl, Grid, Paper, TextField, Typography } from '@mui/material';
import { red } from '@mui/material/colors';

import { Button } from 'primereact/button';
import { Tree, TreeCheckboxSelectionKeys, TreeEventNodeEvent, TreeMultipleSelectionKeys } from 'primereact/tree';
import { Toast } from 'primereact/toast';
import { TreeNode } from 'primereact/treenode';
import { channel } from 'diagnostics_channel';
import { MenuLateral } from '../../components/MenuLateral';

const HomePage: React.FC = () => {

    return (
        <>
            <div className="flex 
            flex-col 
            items-center            
            p-0
            //bg-blue-500
            w-full h-screen">

                home page
             


            </div >
        </>
    );
};

export default HomePage;
